import Layout from '@/layout/index.vue';
export default [
  {
    // 费用中心：确认订单/支付页为内部流转静态路由（菜单页由后端动态返回：feeCenter/service/index、feeCenter/order/index）
    // service/order 注册为 hidden 静态兜底：动态菜单未生效时也能访问，动态菜单生效后静态记录优先匹配，行为一致
    path: '/feeCenter',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'service/orderConfirm',
        component: () => import('@/views/feeCenter/service/orderConfirm.vue'),
        name: 'FeeCenterOrderConfirm',
        meta: { title: '确认订单', icon: '', noCache: true },
      },
      {
        path: 'service/payment',
        component: () => import('@/views/feeCenter/service/payment.vue'),
        name: 'FeeCenterPayment',
        meta: { title: '订单支付', icon: '', noCache: true },
      },
      {
        path: 'service',
        component: () => import('@/views/feeCenter/service/index.vue'),
        name: 'FeeCenterService',
        meta: { title: '增值服务', icon: '', noCache: true },
      },
      {
        path: 'order',
        component: () => import('@/views/feeCenter/order/index.vue'),
        name: 'FeeCenterOrder',
        meta: { title: '订单管理', icon: '', noCache: true },
      },
    ],
  },
];
